// Conditional "Admin" entry point — shown only to admins, navigating to the
// /admin hub. Self-contained (fetches `me` itself + owns the navigate) so it
// can drop into any authenticated surface without that surface needing to wire
// auth/router state. Mirrors how the analytics page is reached: there's no
// global nav chrome, so the link lives on a visited authenticated surface (the
// Focus intro menu).
//
// Rendered as `null` until `me` loads and only when `me.isAdmin` — a non-admin
// never sees it. The route + page are still server-gated regardless.

import { useEffect, useState } from "react";
import { useNavigate } from "@tanstack/react-router";

import { fetchMe } from "../auth/useAuth";
import { useT } from "../i18n/index.js";

export function AdminNavLink({
  className,
}: {
  /** Optional class to match the host surface's chrome styling. */
  readonly className?: string;
}) {
  const t = useT();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchMe()
      .then((me) => {
        if (!cancelled && me) setIsAdmin(me.isAdmin);
      })
      .catch(() => {
        /* best-effort — no link on failure */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isAdmin) return null;

  return (
    <button
      type="button"
      className={className ?? "focus-deeplink"}
      onClick={() => navigate({ to: "/admin" })}
    >
      {t("admin.home.navLabel")}
    </button>
  );
}
